import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from "@mui/material/Typography";
import { IconButton, useTheme, } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EditHeading from './bot-profile-chat/EditHeading';
import NewLiveLocationDetails from './bot-profile-chat/NewLiveLocationDetails';
import UserInfoSection from './bot-profile-chat/UserInfoSection';
import EditAboutInfo from './bot-profile-chat/EditAboutInfo';
import EditAboutLonging from './bot-profile-chat/EditAboutLonging';
import EditLuxeInfo from './bot-profile-chat/EditLuxeInfo';
import VerificationSection from './bot-profile-chat/VerificationSection';
import UserPhotosLayout from './bot-profile-chat/UserPhotosLayout';

export default function BotUserProfile({ open, toggleDrawer, selectedBot,loading=false }) {
  const list = () => (
    <Box
      sx={{
        width: 380,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
      role="presentation"
    >

      {/* ---------- HEADER (fixed) ---------- */}
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid #eee",
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 10,
        }}
      >
        <IconButton
          onClick={toggleDrawer(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: '14px',
            width: '35px',
            height: '35px',
            border: '1px solid #ccc'
          }}
          size="small"
        >
          <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
        </IconButton>

        <Typography variant="h6" textAlign="center" fontWeight={600}>
          Bot Profile Details
        </Typography>
      </Box>

      {
        loading ?
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading...
            </Typography>
          </Box>
          : <>
            {/* ---------- BODY (scrollable) ---------- */}
            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                p: 2,
                pb: 10,  // space for footer
              }}
            >
              <UserPhotosLayout
                photos={selectedBot?.publicPhotos || []}
                title="Public Photos"
                isEditable={false}
                showExtraCount={true}
                isTitleHide={false}
                classCardMedia="Rtmedia"
                classTitlebg="Rttitlebg"
                classTitle="Rttitle"
                classTotalPhoto="Rttotalphoto"
                height70Img="height70Img"
              />
              {/* <UserPhotosLayout
          photos={selectedBot?.privatePhotos || []}
          title="Private Photos"
          isEditable={false}
          showExtraCount={true}
          classCardMedia="Rtmedia"
          classTitlebg="Rttitlebg"
          classTitle="Rttitle"
          classTotalPhoto="Rttotalphoto"
          height70Img="height70Img"
        /> */}
              {
                selectedBot?.myHeading &&
                <EditHeading
                  myHeading={selectedBot?.myHeading}
                  isEditBtn={false}
                  className="pdx"
                  font16in14="fonmgset"
                />
              }
              <NewLiveLocationDetails userData={selectedBot} />
              <UserInfoSection
                memberData={selectedBot}
                isEditBtn={false}
                fieldsToShow={['Gender', 'Occupation', 'Height', 'Relationship', 'Who are you interested in', 'Location',"Intent"]}
                className="pdx"
                classflexinBlock="flexinBlock"
              />
              {
                selectedBot?.aboutUsDescription &&
                <EditAboutInfo memberData={selectedBot} isEditBtn={false} className="pdx" font16in14="fonmgset" />
              }
              {/* {
                selectedBot?.preferences?.aboutPartnerDescription &&
                <EditAboutLonging memberData={selectedBot} isEditBtn={false} className="pdx" font16in14="fonmgset" isRtsdbtnchat="px14font" />
              } */}
              {/* {
                selectedBot?.luxuryInterests &&
                <EditLuxeInfo memberData={selectedBot} isEditBtn={false} className="pdx" isRtsdbtnchat="px14font" />
              } */}
              {
                (
                  selectedBot?.isInstagramVerified ||
                  selectedBot?.isLinkedinVerified ||
                  selectedBot?.isFacebookVerified ||
                  selectedBot?.isTwitterVerified ||
                  selectedBot?.isProfileVerified ||
                  selectedBot?.isIdVerified
                ) &&
                <VerificationSection memberData={selectedBot} showOnlyVerified className="pdx" font16in14="fonmgset" />
              }
            </Box>

            {/* ---------- FOOTER (fixed) ---------- */}
            {/* <Box
        sx={{
          p: 2,
          borderTop: "1px solid #eee",
          position: "sticky",
          bottom: 0,
          backgroundColor: "#fff",
          zIndex: 10,
        }}
      >
        Footer Content here (Buttons / Save etc.)
      </Box> */}
          </>
      }


    </Box>
  );

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        zIndex: 2200,
      }}
    >
      {list()}
    </SwipeableDrawer>
  );
}
